import { Button, Checkbox, Switch, Upload } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { getPlatformOptions } from './download-version-form';
import { VersionSelect } from './select-version';
import { UploadChangeParam, UploadFile, UploadProps } from 'antd/lib/upload';
import { DeleteOutlined } from '@ant-design/icons';
import messageEmpty from '../../../../assets/images/message-empty.png';
import getFormatMessage from '../../../../locales/get-format-message';
import { useEffect, useState } from 'react';

import { messageWarning } from '../../../../components/message';
import {
  DownloadEngine,
  IDownLoadMenu,
  IDownLoadVersionMenu,
  ISecondEngineItem,
} from '../../../../model/api-modules';
import {
  currentSiteDownloadUpload,
  getLocalDownloadCosConfig,
} from './multi-site-cos';
import { CommonSelect } from '../../../../components/select';
import { getValueText } from '../../../../lib';
import moment from 'moment';
import { set } from 'lodash';

interface IProps {
  readonly data: any;
  readonly setEngine: (data: any) => void;
  readonly onDelete: (key: string) => void;
  readonly index: number;
  readonly selectDownloadObjectType: number;
  readonly selectDownloadObjectName: string;
  readonly setLoading: (value: boolean) => void;
  readonly viewOnly?: boolean;
  readonly secondList: IDownLoadMenu[];
  readonly secondJson: Record<string, ISecondEngineItem[]>;
  readonly setSecondJson: (value: Record<string, ISecondEngineItem[]>) => void;
  readonly downLoadList: readonly IDownLoadMenu[];
  readonly row: IDownLoadVersionMenu | null;
}

export const AddEngine = (props: IProps) => {
  const { viewOnly = false, setSecondJson } = props;
  const secondJson = props.secondJson[props.data.key] || [];
  const [isBaseSdk, setIsBaseSdk] = useState<Boolean>(false);
  const CheckboxGroup = Checkbox.Group;
  const noDisabledSelect = props.selectDownloadObjectType === 1;
  // const isBaseSdk = props.selectDownloadObjectName === 'InGame Base SDK';
  // BaseSdk的只能是c++引擎
  const optionsName = [
    { label: 'UE Plugin', value: 1 },
    { label: 'C++', value: 2 },
    { label: 'Unity Plugin', value: 3 },
  ];
  const defaultOption = optionsName.find((option) => option.label === 'C++');
  const [selectedValue, setSelectedValue] = useState<number>(
    defaultOption?.value || 2
  );

  const isOld = () => {
    const { row } = props;
    if (props.secondList.length !== 0 && secondJson.length === 0) {
      if (row && row.EngineJson.length > 0) {
        return true;
      }
    }
    return false;
  };

  let currentEngineType = props.data.type ? props.data.type : selectedValue;
  let currentPackage = props.data?.package;
  if (
    props.secondList.length !== 0 &&
    secondJson.length !== 0 &&
    secondJson[0]?.EngineJson[0]?.type &&
    !isOld()
  ) {
    currentEngineType = secondJson[0]?.EngineJson[0]?.type;
    currentPackage = secondJson[0]?.EngineJson[0]?.package || [];
  }

  const packageList: any[] = [];
  currentPackage &&
    currentPackage.length !== 0 &&
    currentPackage.forEach((item: any) => {
      packageList.push({
        name: item.file,
      });
    });
  const handleNameChange = (value: number) => {
    setSelectedValue(value);

    if (props.secondList.length !== 0 && secondJson.length !== 0 && !isOld()) {
      const newSecondJson: ISecondEngineItem[] = [];
      secondJson?.forEach((it: ISecondEngineItem) => {
        newSecondJson.push({
          key: it.key,
          ObjectTag: it.ObjectTag,
          EngineJson: [
            {
              ...it.EngineJson[0],
              type: value,
              gdkVersion:
                value === DownloadEngine.CPP ? [] : it.EngineJson[0].gdkVersion,
              pssdkVersion:
                value === DownloadEngine.CPP
                  ? []
                  : it.EngineJson[0].pssdkVersion,
            },
          ],
        });
      });
      setSecondJson({
        ...props.secondJson,
        [props.data.key]: newSecondJson,
      });
    } else {
      let newData = {
        ...props.data,
        type: value,
      };
      if (value === DownloadEngine.CPP) {
        // 如果选中的是 C++
        newData = {
          ...newData,
          pssdkVersion: [], // 清空 pssdkVersion 的值
          gdkVersion: [], // 清空 gdkVersion 的值
        };
      }
      props.setEngine(newData);
    }
  };

  const onDelete = (ObjectTag?: string) => {
    const newSecondJson: ISecondEngineItem[] = [];
    secondJson?.forEach((item: ISecondEngineItem) => {
      if (item.ObjectTag !== ObjectTag) {
        newSecondJson.push(item);
      }
    });
    setSecondJson({
      ...props.secondJson,
      [props.data.key]: newSecondJson,
    });
  };

  const handleSecondChange = (
    value: any,
    item: ISecondEngineItem,
    key: string
  ) => {
    const newSecondJson: ISecondEngineItem[] = [];
    secondJson?.forEach((it: ISecondEngineItem) => {
      if (item.ObjectTag !== it.ObjectTag) {
        newSecondJson.push(it);
      } else {
        newSecondJson.push({
          key: it.key,
          ObjectTag: key === 'tag' ? value : it.ObjectTag,
          EngineJson: [
            {
              type: it.EngineJson[0].type,
              version: key === 'version' ? value : it.EngineJson[0].version,
              platform: key === 'platform' ? value : it.EngineJson[0].platform,
              package: key === 'package' ? value : it.EngineJson[0].package,
              openGDKVersion:
                key === 'openGDKVersion'
                  ? value
                  : it.EngineJson[0].openGDKVersion,
              gdkVersion:
                key === 'gdkVersion' ? value : it.EngineJson[0].gdkVersion,
              openPSSDKVersion:
                key === 'openPSSDKVersion'
                  ? value
                  : it.EngineJson[0].openPSSDKVersion,
              pssdkVersion:
                key === 'pssdkVersion' ? value : it.EngineJson[0].pssdkVersion,
            },
          ],
        });
      }
    });
    setSecondJson({
      ...props.secondJson,
      [props.data.key]: newSecondJson,
    });
  };

  const handleAddSecond = (type?: number) => {
    const newSecondJson = Object.assign([], secondJson);
    const id = (Math.random() * 100).toString(32).slice(3, 7);
    const time = moment().format('YYMMDDHHmmss');
    newSecondJson.push({
      key: `second-${time}-${id}`,
      ObjectTag: '',
      EngineJson: [
        {
          type: type || 2,
          version: [],
          platform: [],
          package: [],
          openGDKVersion: false,
          gdkVersion: [],
          openPSSDKVersion: false,
          pssdkVersion: [],
        },
      ],
    });
    setSecondJson({
      ...props.secondJson,
      [props.data.key]: newSecondJson,
    });
  };

  useEffect(() => {
    setIsBaseSdk(props.selectDownloadObjectName === 'InGame Base SDK');
    if (props.secondList.length !== 0 && secondJson.length === 0 && !isOld()) {
      handleAddSecond();
    }
  }, [props.selectDownloadObjectName]);

  const handlePlatformsChange = (checkedValues: CheckboxValueType[]) => {
    const newData = {
      ...props.data,
      platform: checkedValues,
    };
    props.setEngine(newData);
  };

  const handleVersionsChange = (versions: string[]) => {
    const newData = {
      ...props.data,
      version: versions,
    };
    props.setEngine(newData);
  };

  const handlePSSDKVersionsChange = (versions: string[]) => {
    const newData = {
      ...props.data,
      pssdkVersion: versions,
    };
    props.setEngine(newData);
  };

  const handleGDKVersionsChange = (versions: string[]) => {
    const newData = {
      ...props.data,
      gdkVersion: versions,
    };
    props.setEngine(newData);
  };

  const beforeUpload = () => {
    // 取消默认上传行为
    return false;
  };

  const handleUpload: UploadProps['onChange'] = async (
    info: UploadChangeParam<UploadFile>
  ) => {
    const files = Object.assign([], [info.file]);
    console.log('上传文件:', files);
    const file: any = files[0];
    const splitArr = file.name.split('.');
    if (splitArr[splitArr.length - 1] !== 'zip') {
      messageWarning('Only zip files allowed to be uploaded');
      return false;
    }
    uploadTo(files);
  };

  // 上传
  const uploadTo = async (files: ReadonlyArray<File>) => {
    props.setLoading(true);
    // const uploadURL: string[] = [];

    const file: any = files[0];
    let currentPackage = props.data?.package;
    if (props.secondList.length !== 0 && secondJson.length !== 0 && !isOld()) {
      currentPackage = secondJson[0]?.EngineJson[0]?.package || [];
    }

    if (file.status && file.status === 'removed') {
      console.log('删除该文件', file.name);
      const newPackage: any = [];
      currentPackage.forEach((item: any) => {
        if (item.file !== file.name) {
          newPackage.push(item);
        }
      });
      const newData = {
        ...props.data,
        package: newPackage,
      };

      if (
        props.secondList.length !== 0 &&
        secondJson.length !== 0 &&
        !isOld()
      ) {
        const newSecondJson: ISecondEngineItem[] = [];
        secondJson.forEach((it) => {
          const newEngineJson = [...it.EngineJson];
          set(newEngineJson, '[0].package', newPackage);
          newSecondJson.push({
            ...it,
            EngineJson: newEngineJson,
          });
        });
        setSecondJson({
          ...props.secondJson,
          [props.data.key]: newSecondJson,
        });
      }
      props.setEngine(newData);
      props.setLoading(false);
      return;
    }

    if (!getLocalDownloadCosConfig()) {
      props.setLoading(false);
      console.log('上传失败', '未获取到cos桶配置');
      return;
    }

    // 上传cos
    const data = await currentSiteDownloadUpload(file.name, file);

    const fileMeta = data?.[0];
    if (fileMeta) {
      // const newPackage = Object.assign([], currentPackage);
      const newPackage: any[] = []; // 删除之前的包
      const fileUrlArr = fileMeta.Location.split('/');
      const fileName = fileUrlArr[fileUrlArr.length - 1];
      newPackage.push({
        size: Math.floor(file.size / 1048576) || 1,
        file: fileName,
        etag: fileMeta.ETag.replace(/"/g, ''),
      });
      const newData = {
        ...props.data,
        package: newPackage,
      };
      props.setEngine(newData);
      props.setLoading(false);
      if (
        props.secondList.length !== 0 &&
        secondJson.length !== 0 &&
        !isOld()
      ) {
        const newSecondJson: ISecondEngineItem[] = [];
        secondJson.forEach((it) => {
          const newEngineJson = [...it.EngineJson];
          set(newEngineJson, '[0].package', newPackage);
          newSecondJson.push({
            ...it,
            EngineJson: newEngineJson,
          });
        });
        setSecondJson({
          ...props.secondJson,
          [props.data.key]: newSecondJson,
        });
      }
      console.log('上传成功', data);
      return;
    }
    props.setLoading(false);
    console.log('上传失败');
  };

  const handleDelete = () => {
    props.onDelete(props.data.key);
  };

  const clickShowPSSDKVersion = (checked: boolean) => {
    const newData = {
      ...props.data,
      openPSSDKVersion: checked,
    };
    props.setEngine(newData);
  };

  const clickShowGDKVersion = (checked: boolean) => {
    const newData = {
      ...props.data,
      openGDKVersion: checked,
    };
    props.setEngine(newData);
  };

  if (viewOnly) {
    return (
      <div className="drawer-download-text add-engine-content">
        {props.index !== 0 && (
          <span className="del-btn" onClick={handleDelete}>
            <DeleteOutlined
              style={{ position: 'relative', top: '18px', left: '60px' }}
            />
          </span>
        )}
        {noDisabledSelect ? (
          <>
            <div style={{ marginBottom: '12px' }}>
              <span style={{ marginRight: '10px' }}>引擎名称</span>
            </div>

            {getValueText(
              isBaseSdk ? optionsName[1].value : currentEngineType,
              optionsName
            )}

            {props.secondList.length === 0 ||
            (props.row && props.row.EngineJson.length !== 0) ? (
              <>
                {/*  basesdk的时候不展示 */}
                {!isBaseSdk && (
                  <div style={{ marginTop: '12px' }}>
                    <div style={{ marginBottom: '12px' }}>
                      {props.data.type === DownloadEngine.UEPlugin &&
                        getFormatMessage('ue_version')}
                      {props.data.type === DownloadEngine.UnityPlugin &&
                        getFormatMessage('unity_version')}
                      {props.data.type === DownloadEngine.CPP && 'STL Version'}
                    </div>
                    {props.data?.version?.join(', ')}
                  </div>
                )}
                <div style={{ marginTop: '12px' }}>
                  {getFormatMessage('platforms')}
                </div>

                {getValueText(props.data.platform, getPlatformOptions()).join?.(
                  ', '
                )}

                {/*  为isBaseSdk的时候不展示pssdkVersion,gdkVersion内容 */}
                {!isBaseSdk && (
                  <>
                    <div style={{ marginTop: '12px', marginBottom: '12px' }}>
                      <label>
                        <span style={{ marginRight: '15px' }}>
                          {getFormatMessage('ps_sdk_version')}
                        </span>
                        <Switch
                          checked={props.data.openPSSDKVersion}
                          onChange={(checked) => clickShowPSSDKVersion(checked)}
                          disabled={viewOnly}
                        />
                      </label>
                      {props.data.openPSSDKVersion && (
                        <div>{props.data?.pssdkVersion?.join(', ')}</div>
                      )}
                    </div>
                    <div style={{ marginTop: '12px', marginBottom: '12px' }}>
                      <label>
                        <span
                          style={{ marginRight: '15px', marginBottom: '12px' }}
                        >
                          {getFormatMessage('gdk_version')}
                        </span>
                        <Switch
                          checked={props.data.openGDKVersion}
                          onChange={(checked) => clickShowGDKVersion(checked)}
                          disabled={viewOnly}
                        />
                      </label>
                      {props.data.openGDKVersion && (
                        <div>{props.data?.gdkVersion?.join(', ')}</div>
                      )}
                    </div>
                  </>
                )}
              </>
            ) : (
              secondJson.map((item) => {
                const itemName =
                  props.secondList.find((it) => it.Tag === item.ObjectTag)
                    ?.Name || '';
                return (
                  <>
                    <div style={{ marginBottom: '12px' }}>
                      <span style={{ marginRight: '10px' }}>
                        二级下载物名称
                      </span>
                    </div>
                    {itemName}
                    {/*  basesdk的时候不展示 */}
                    {!isBaseSdk && (
                      <div style={{ marginTop: '12px' }}>
                        <div style={{ marginBottom: '12px' }}>
                          {item.EngineJson[0]?.type ===
                            DownloadEngine.UEPlugin &&
                            getFormatMessage('ue_version')}
                          {item.EngineJson[0]?.type ===
                            DownloadEngine.UnityPlugin &&
                            getFormatMessage('unity_version')}
                          {item.EngineJson[0]?.type === DownloadEngine.CPP &&
                            'STL Version'}
                        </div>
                        {item.EngineJson[0]?.version?.join(', ')}
                      </div>
                    )}
                    <div style={{ marginTop: '12px' }}>
                      {getFormatMessage('platforms')}
                    </div>

                    {getValueText(
                      item.EngineJson[0]?.platform,
                      getPlatformOptions()
                    ).join?.(', ')}

                    {/*  为isBaseSdk的时候不展示pssdkVersion,gdkVersion内容 */}
                    {!isBaseSdk && (
                      <>
                        <div
                          style={{ marginTop: '12px', marginBottom: '12px' }}
                        >
                          <label>
                            <span style={{ marginRight: '15px' }}>
                              {getFormatMessage('ps_sdk_version')}
                            </span>
                            <Switch
                              checked={item.EngineJson[0]?.openPSSDKVersion}
                              onChange={(checked) =>
                                clickShowPSSDKVersion(checked)
                              }
                              disabled={viewOnly}
                            />
                          </label>
                          {item.EngineJson[0]?.openPSSDKVersion && (
                            <div>
                              {item.EngineJson[0]?.pssdkVersion?.join(', ')}
                            </div>
                          )}
                        </div>
                        <div
                          style={{ marginTop: '12px', marginBottom: '12px' }}
                        >
                          <label>
                            <span
                              style={{
                                marginRight: '15px',
                                marginBottom: '12px',
                              }}
                            >
                              {getFormatMessage('gdk_version')}
                            </span>
                            <Switch
                              checked={item.EngineJson[0]?.openGDKVersion}
                              onChange={(checked) =>
                                clickShowGDKVersion(checked)
                              }
                              disabled={viewOnly}
                            />
                          </label>
                          {item.EngineJson[0]?.openGDKVersion && (
                            <div>
                              {item.EngineJson[0]?.gdkVersion?.join(', ')}
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </>
                );
              })
            )}
          </>
        ) : null}

        <div>{getFormatMessage('package')}</div>
        <div>{packageList?.map((item) => item.name).join('\n')}</div>
      </div>
    );
  }

  return (
    <div className="drawer-download-text add-engine-content">
      {props.index !== 0 && (
        <span className="del-btn" onClick={handleDelete}>
          <DeleteOutlined
            style={{ position: 'relative', top: '18px', left: '60px' }}
          />
        </span>
      )}
      {noDisabledSelect ? (
        <>
          <div style={{ marginBottom: '12px' }}>
            <span style={{ marginRight: '10px' }}>引擎名称</span>
          </div>
          <CommonSelect
            value={isBaseSdk ? optionsName[1].value : currentEngineType}
            onChange={(e) => handleNameChange(e)}
            options={optionsName.filter(
              (item) => !(isBaseSdk && item.value !== 2)
            )}
          ></CommonSelect>

          {props.secondList.length === 0 ||
          (props.row && props.row.EngineJson.length !== 0) ? (
            <>
              {/*  basesdk的时候不展示 */}
              {!isBaseSdk && (
                <div style={{ marginTop: '12px' }}>
                  <div style={{ marginBottom: '12px' }}>
                    {props.data.type === DownloadEngine.UEPlugin &&
                      getFormatMessage('ue_version')}
                    {props.data.type === DownloadEngine.UnityPlugin &&
                      getFormatMessage('unity_version')}
                    {props.data.type === DownloadEngine.CPP && 'STL Version'}
                  </div>
                  <VersionSelect
                    placeholderText={getFormatMessage('please_enter_version')}
                    selectedVersions={props.data.version}
                    onVersionsChange={handleVersionsChange}
                  />
                </div>
              )}
              <div style={{ marginTop: '12px' }}>
                {getFormatMessage('platforms')}
              </div>
              <CheckboxGroup
                options={getPlatformOptions()}
                value={props.data.platform}
                onChange={(checkedValues) =>
                  handlePlatformsChange(checkedValues)
                }
                className="download-checkbox"
              />
              {/*  为isBaseSdk的时候不展示pssdkVersion,gdkVersion内容 */}
              {!isBaseSdk && (
                <>
                  <div style={{ marginTop: '12px', marginBottom: '12px' }}>
                    <label>
                      <span style={{ marginRight: '15px' }}>
                        {getFormatMessage('ps_sdk_version')}
                      </span>
                      <Switch
                        checked={props.data.openPSSDKVersion}
                        onChange={(checked) => clickShowPSSDKVersion(checked)}
                      />
                    </label>
                    {props.data.openPSSDKVersion && (
                      <VersionSelect
                        placeholderText={getFormatMessage(
                          'please_enter_version'
                        )}
                        selectedVersions={props.data.pssdkVersion}
                        onVersionsChange={handlePSSDKVersionsChange}
                      />
                    )}
                  </div>
                  <div style={{ marginTop: '12px', marginBottom: '12px' }}>
                    <label>
                      <span
                        style={{ marginRight: '15px', marginBottom: '12px' }}
                      >
                        {getFormatMessage('gdk_version')}
                      </span>
                      <Switch
                        checked={props.data.openGDKVersion}
                        onChange={(checked) => clickShowGDKVersion(checked)}
                      />
                    </label>
                    {props.data.openGDKVersion && (
                      <VersionSelect
                        placeholderText={getFormatMessage(
                          'please_enter_version'
                        )}
                        selectedVersions={props.data.gdkVersion}
                        onVersionsChange={handleGDKVersionsChange}
                      />
                    )}
                  </div>
                </>
              )}
            </>
          ) : (
            secondJson.map((item, idx) => {
              return (
                <>
                  {idx !== 0 && (
                    <span
                      className="del-btn"
                      onClick={() => onDelete(item.ObjectTag)}
                    >
                      <DeleteOutlined
                        style={{
                          position: 'relative',
                          top: '18px',
                          left: '105px',
                        }}
                      />
                    </span>
                  )}
                  <div style={{ marginBottom: '12px' }}>
                    <span style={{ marginRight: '10px' }}>二级下载物名称</span>
                  </div>
                  <CommonSelect
                    value={item.ObjectTag}
                    onChange={(e) => handleSecondChange(e, item, 'tag')}
                    options={props.secondList.map((it) => {
                      const secondItem = secondJson.find(
                        (jsonItem) => jsonItem.ObjectTag === it.Tag
                      );
                      return {
                        label: it.Name,
                        value: it.Tag,
                        disabled: !!secondItem && item.ObjectTag !== it.Tag,
                      };
                    })}
                  ></CommonSelect>
                  {/*  basesdk的时候不展示 */}
                  {!isBaseSdk && (
                    <div style={{ marginTop: '12px' }}>
                      <div style={{ marginBottom: '12px' }}>
                        {item.EngineJson[0]?.type === DownloadEngine.UEPlugin &&
                          getFormatMessage('ue_version')}
                        {item.EngineJson[0]?.type ===
                          DownloadEngine.UnityPlugin &&
                          getFormatMessage('unity_version')}
                        {item.EngineJson[0]?.type === DownloadEngine.CPP &&
                          'STL Version'}
                      </div>
                      <VersionSelect
                        placeholderText={getFormatMessage(
                          'please_enter_version'
                        )}
                        selectedVersions={
                          item.EngineJson[0]?.version as string[]
                        }
                        onVersionsChange={(value) =>
                          handleSecondChange(value, item, 'version')
                        }
                      />
                    </div>
                  )}
                  <div style={{ marginTop: '12px' }}>
                    {getFormatMessage('platforms')}
                  </div>
                  <CheckboxGroup
                    options={getPlatformOptions()}
                    value={item.EngineJson[0]?.platform as any}
                    onChange={(value) =>
                      handleSecondChange(value, item, 'platform')
                    }
                    className="download-checkbox"
                  />
                  {/*  为isBaseSdk的时候不展示pssdkVersion,gdkVersion内容 */}
                  {!isBaseSdk && (
                    <>
                      <div style={{ marginTop: '12px', marginBottom: '12px' }}>
                        <label>
                          <span style={{ marginRight: '15px' }}>
                            {getFormatMessage('ps_sdk_version')}
                          </span>
                          <Switch
                            checked={item.EngineJson[0]?.openPSSDKVersion}
                            onChange={(value) =>
                              handleSecondChange(
                                value,
                                item,
                                'openPSSDKVersion'
                              )
                            }
                          />
                        </label>
                        {item.EngineJson[0]?.openPSSDKVersion && (
                          <VersionSelect
                            placeholderText={getFormatMessage(
                              'please_enter_version'
                            )}
                            selectedVersions={
                              item.EngineJson[0]?.pssdkVersion as string[]
                            }
                            onVersionsChange={(value) =>
                              handleSecondChange(value, item, 'pssdkVersion')
                            }
                          />
                        )}
                      </div>
                      <div style={{ marginTop: '12px', marginBottom: '12px' }}>
                        <label>
                          <span
                            style={{
                              marginRight: '15px',
                              marginBottom: '12px',
                            }}
                          >
                            {getFormatMessage('gdk_version')}
                          </span>
                          <Switch
                            checked={item.EngineJson[0]?.openGDKVersion}
                            onChange={(value) =>
                              handleSecondChange(value, item, 'openGDKVersion')
                            }
                          />
                        </label>
                        {item.EngineJson[0]?.openGDKVersion && (
                          <VersionSelect
                            placeholderText={getFormatMessage(
                              'please_enter_version'
                            )}
                            selectedVersions={
                              item.EngineJson[0]?.gdkVersion as string[]
                            }
                            onVersionsChange={(value) =>
                              handleSecondChange(value, item, 'gdkVersion')
                            }
                          />
                        )}
                      </div>
                    </>
                  )}
                </>
              );
            })
          )}
        </>
      ) : null}

      {props.secondList.length !== 0 && !props.viewOnly && !isOld() && (
        <Button
          className="engine-btn"
          onClick={() => handleAddSecond(secondJson[0]?.EngineJson[0]?.type)}
          disabled={secondJson.length === props.secondList.length}
        >
          + 添加二级下载物
        </Button>
      )}

      <div>{getFormatMessage('package')}</div>
      <div>
        <Upload
          beforeUpload={beforeUpload}
          onChange={handleUpload}
          fileList={packageList}
        >
          <div className="upload-container">
            <img src={messageEmpty} />
            <p className="files">
              {getFormatMessage('drop_files_desc')}
              <span>{getFormatMessage('browse')}</span>
            </p>
          </div>
        </Upload>
      </div>
    </div>
  );
};
